import Account from '@/components/dtcPartnerships/Account';
import Eligibility from '@/components/dtcPartnerships/Eligibility';
import Error from '@/components/dtcPartnerships/Error';
import Payment from '@/components/dtcPartnerships/Payment';
import Sorry from '@/components/dtcPartnerships/Sorry';
import Success from '@/components/dtcPartnerships/Success';
import Welcome from '@/components/dtcPartnerships/Welcome';

import { SignupScreenProps, SignupScreensKey } from '../shared/types';

export const signupScreens: Record<
	SignupScreensKey,
	{ readonly Component: React.FC<SignupScreenProps>; readonly name: string }
> = {
	account: {
		Component: Account,
		name: 'DTCPartnerships : Account',
	},
	eligibility: {
		Component: Eligibility,
		name: 'DTCPartnerships : Eligibility',
	},
	error: {
		Component: Error,
		name: 'DTCPartnerships : Error',
	},
	payment: {
		Component: Payment,
		name: 'DTCPartnerships : Payment',
	},
	sorry: {
		Component: Sorry,
		name: 'DTCPartnerships : Sorry',
	},
	success: {
		Component: Success,
		name: 'DTCPartnerships : Success',
	},
	welcome: {
		Component: Welcome,
		name: 'DTCPartnerships : Welcome',
	},
} as const;
